import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import {
    AuthorityMapSvgLarge,
    AuthorityMapSvgSmall
} from '$partials/ui';

import { RegionItem } from '$partials/listings';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleAuthorityMapBlock = ({ regionItems = null }) => {
    // state
    const [ activeRegion, setActiveRegion ] = useState('');
    const [ isSmallScreen, setIsSmallScreen ] = useState(true);

    // methods
    const getRegionItemComponent = (region) => {
        const item = regionItems?.edges?.find(item => item.node.slug === region);

        if (item) {
            return (
                <RegionItem
                    onClose={setActiveRegion.bind(null, null)}
                    {...item.node} />
            );
        } else {
            return null;
        }
    };

    // methods
    const handleResize = () => {
        if (window.innerWidth < 768 && !isSmallScreen) {
            setIsSmallScreen(true);
        }

        if (window.innerWidth >= 768 && isSmallScreen) {
            setIsSmallScreen(false);
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize, { passive: true });

        handleResize();

        return () =>  window.removeEventListener('resize', handleResize);
    }, [ isSmallScreen ]);

    useEffect(() => {
        if (window.innerWidth >= 768) {
            setActiveRegion('london');
        }
    }, []);

    // render
    return (
        <div className='relative bg-sand'>
            <div className='md:layout-container'>
                <div className='md:layout-grid-negative-gutter'>
                    <div className='flex flex-wrap'>
                        <div className='md:w-4/12 md:layout-grid-col-padding' />

                        <div className='w-12/12 md:w-8/12 md:layout-grid-col-padding pb-20'>
                            {isSmallScreen ? (
                                <AuthorityMapSvgSmall
                                    activeRegion={activeRegion}
                                    setActiveRegion={setActiveRegion} />
                            ) : (
                                <AuthorityMapSvgLarge
                                    activeRegion={activeRegion}
                                    setActiveRegion={setActiveRegion} />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile & tablet */}
            {activeRegion && (
                <div className='md:hidden absolute bottom-0 bg-white py5 w-full'>
                    {getRegionItemComponent(activeRegion)}
                </div>
            )}

            {/* Desktop */}
            {activeRegion && (
                <div className='hidden md:block absolute top-0 left-0 mt-60 w-full pointer-events-none'>
                    <div className='layout-container'>
                        <div className='layout-grid-negative-gutter'>
                            <div className='flex flex-wrap'>
                                <div className='w-1/12' />

                                <div className='md:w-4/12 layout-grid-col-padding bg-white pointer-events-auto'>
                                    {getRegionItemComponent(activeRegion)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = { regionItems: PropTypes.object };

ModuleAuthorityMapBlock.propTypes = propTypes;

export default ModuleAuthorityMapBlock;
